import React from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import PharmacyProfileSidebar from "../Components/PharmacyProfileSidebar";

const PharmacyPassword = () => {
	return (
		<>
			<Header />
			<PageHeader pagename="Pharmacy Profile" />
			<section className="main-sidebar user-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<PharmacyProfileSidebar />
						</div>
						<div className="col-lg-8">
							<div className="main-profile-content radius-20 p-4">
								<div className="main-headind d-flex align-items-center 	gap-3 mb-3">
									<div class="edit-btn back">
										<Link to="/">
											<div class="nav-anchor">
												<i class="fa-solid fa-arrow-left"></i>
											</div>
										</Link>
									</div>
									<h5 class="main-heading level-6 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s ">
										Change Password
									</h5>
								</div>
								<form>
									<div className="row">
										<div className="form-group col-lg-12">
											<input
												type="text"
												className="form-control"
												id="firstName"
												placeholder=" Old Password"
											/>
										</div>
										<div className="form-group col-lg-12">
											<input
												type="text"
												className="form-control"
												id="lastName"
												placeholder=" New Password"
											/>
										</div>
										<div className="form-group col-lg-12">
											<input
												type="text"
												className="form-control"
												id="lastName"
												placeholder=" Confirm Password"
											/>
										</div>
									</div>
									<Link
										class="btn wrapper-btn-main mb-5 log-in mt-3 level-7 primary-regular-font text-decoration-none"
										to=""
									>
										<span class="bg-wrapper ">Save Changes</span>
									</Link>
								</form>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default PharmacyPassword;
